import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus, Trash2 } from "lucide-react";
import { api, data, errMsg } from "@/lib/api";
import { Spinner } from "@/components/Layout";

const DESCR = { cassa: "Solo verifica e riscatto gift card", gestore: "Vetrina, vendite, saldi e riscatto (no piano, incassi e team)" };

export default function Team() {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState({ nome: "", email: "", ruolo_azienda: "cassa" });
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/operatore/team").then((r) => setRows(r.data)), []);
  useEffect(() => {
    load();
  }, [load]);
  if (!rows) return <Spinner />;
  const invita = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/operatore/team", f);
      toast.success(`Invito inviato a ${f.email}`);
      setF({ nome: "", email: "", ruolo_azienda: "cassa" });
      load();
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };
  const rimuovi = async (id) => {
    if (!window.confirm("Rimuovere l'accesso a questo membro?")) return;
    await api.delete(`/operatore/team/${id}`);
    load();
  };
  return (
    <div className="grid lg:grid-cols-5 gap-8">
      <form onSubmit={invita} className="card lg:col-span-2 space-y-4" data-testid="team-form">
        <h3 className="font-display text-2xl">Aggiungi un collaboratore</h3>
        <input required className="field" placeholder="Nome" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} data-testid="team-nome-input" />
        <input required type="email" className="field" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="team-email-input" />
        <select className="field" value={f.ruolo_azienda} onChange={(e) => setF({ ...f, ruolo_azienda: e.target.value })} data-testid="team-ruolo-select">
          <option value="cassa">Cassa</option>
          <option value="gestore">Gestore</option>
        </select>
        <p className="text-xs text-[#786E65]">{DESCR[f.ruolo_azienda]}. Riceverà un'email per impostare la password; anche per lui la 2FA è obbligatoria.</p>
        <button className="btn-primary w-full" disabled={busy} data-testid="team-invita-btn"><UserPlus size={16} />{busy ? "Invio…" : "Invia invito"}</button>
      </form>
      <div className="card lg:col-span-3 overflow-x-auto">
        <table className="tbl" data-testid="team-table">
          <thead><tr><th>Nome</th><th>Email</th><th>Ruolo</th><th>Dal</th><th></th></tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} data-testid={`team-row-${m.id}`}>
                <td>{m.nome}</td><td>{m.email}</td><td><span className="badge-gold">{m.ruolo_azienda}</span></td><td>{data(m.created_at)}</td>
                <td><button className="btn-secondary btn-sm" onClick={() => rimuovi(m.id)} data-testid={`team-rimuovi-${m.id}`}><Trash2 size={14} /></button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} className="text-center text-[#786E65]">Nessun collaboratore</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
